import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

export interface MobileMenuItemInputs {
  label: string;
  icon: string;
  route: string;
  permission: boolean;
  clickCallback?: () => void;
}
@Component({
  selector: 'app-mobile-menu-item',
  imports: [TranslateModule, RouterModule],
  templateUrl: './mobile-menu-item.component.html',
  styleUrl: './mobile-menu-item.component.scss',
})
export class MobileMenuItemComponent {
  @Input() label!: string;
  @Input() icon!: string;
  @Input() route!: string;
  // @Input() clickCallback!: () => void;
  currentLAnguage: string;
  get isArabic() {
    return this.currentLAnguage === 'ar';
  }
  constructor(public translate: TranslateService) {
    this.currentLAnguage = this.translate.currentLang;
    this.translate.onLangChange.subscribe(lang => {
      this.currentLAnguage = lang.lang;
    });
  }
  // onClick() {
  //   this.clickCallback();
  // }
}
